module.exports = __webpack_public_path__ + "static/media/H1.f98383a1.png";